// Fyll i kundens riktiga profiladresser och porträttets bildsökväg när de finns.
// Tomma värden visas inte på hemsidan.
export const siteDetails = {
  facebook: "https://www.facebook.com/p/Mureri-Eldst%C3%A4der-61580110710259/",
  instagram: "https://www.instagram.com/mureriocheldstader/",
  portrait: ""
};
